<template>
  <div class="">
    <v-file-input v-if="progress === 0" v-model="file" :label="label" :placeholder="placeholder"
                  prepend-icon="mdi-paperclip"
                  :accept="accept"
                  clearable outlined chips hide-details
                  @change="createChunks"
                  @click:append-outer="createChunks"
    >
    </v-file-input>

    <v-progress-linear v-if="progress > 0" v-model="progress" color="primary" height="25">
      <template v-slot:default="{ value }">{{ Math.ceil(value) }}%</template>
    </v-progress-linear>
  </div>
</template>

<script>
export default {
  name: 'file-uploader',
  props: {
    upload_url: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
      default: 'image/png, image/jpeg, image/bmp',
    }
  },
  data: () => ({
    file: null,
    chunk_size: 500 * 1024,
    chunks: [],
    uploaded: 0
  }),
  computed: {
    progress() {
      if(!this.file) return 0
      return Math.floor((this.uploaded * 100) / this.file.size);
    },
  },
  watch: {
    chunks: function (n) {
      if (n.length > 0) this.upload();
    }
  },
  methods: {
    async upload() {
      let chunk =  this.chunks[0]
      let formData = new FormData;
      this.uploaded+=chunk.size
      formData.set('is_last', this.chunks.length === 1);
      formData.set('file', chunk, `${this.file.name}.part`);
      await this.axios({
        method: 'POST',
        data: formData,
        url: this.upload_url,
        headers: {'Content-Type': 'application/octet-stream'},
      })
          .then(({data}) => {
            if(data.data) {
              this.$emit('uploaded', data.data)
              this.file = null
              this.uploaded = 0
            }
            this.chunks.shift();
          })
          .catch(error => {
            this.$emit('failed', error)
            this.file = null
            this.uploaded = 0
          });
    },
    createChunks() {
      let chunkSize = 1024 * 1024;
      let chunks = Math.ceil(this.file.size / chunkSize);

      let chunk = 0;
      let blobs = []
      while (chunk <= chunks) {
        let offset = chunk * chunkSize;
        blobs.push(this.file.slice(offset, offset+chunkSize))
        chunk++;
      }
      this.chunks = blobs
    }
  }
}
</script>
